<template>
  <SlideIn :open="isOpen" heading="Sign Up" @close="isOpen = false">
    <template #content>
      <RegisterPanel />
    </template>
  </SlideIn>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import RegisterPanel from "@/components/account/RegisterPanel.vue";
import SlideIn from "@/components/SlideIn.vue";

export default {
  name: "SlideSignUp",
  components: {
    RegisterPanel,
    SlideIn,
  },
  computed: {
    ...mapState("app", ["isSlideSignUpOpen"]),
    ...mapGetters("app", ["currencyCode"]),
    isOpen: {
      get() {
        return this.isSlideSignUpOpen;
      },
      set(value) {
        this.setSlideSignUp(value);
      },
    },
  },
  methods: {
    ...mapActions("app", ["setSlideSignUp"]),
  },
};
</script>
